<!-- =========================================================================================
  File Name: PageNotifications.vue
  Description: Data List - List View Notifications
  ----------------------------------------------------------------------------------------
  Author: Thu Huynh
========================================================================================== -->
<i18n>
{
	"en": {
		"DeleteSelected": "Delete selected",
		"DeleteAll": "Delete all",
		"MarkRead": "Mark read"
	},
	"vi": {
		"DeleteSelected": "Xoá mục đã chọn",
		"DeleteAll": "Xoá tất cả",
		"MarkRead": "Đánh dấu đã đọc"
	}
}
</i18n>


<template>
	<div id="data-list-list-view-notifications" class="data-list-container">
		<vs-table
			ref="table"
			:sst="true"
			v-model="selected"
			id="table-data-notifications"
			class="vs-con-loading__container stack-table"
			:noDataText="$t('Notify.NoDataAvailable')"
			:data="notifications"
			:multiple="$store.state.notifications.totalNotifications > 0"
		>
			<div slot="header" class="flex flex-grow justify-end">
				<vs-input size="large" icon="search" v-model="searching" @input="handleSearch" :placeholder="$t('Actions.Search')" class="input-search mr-3 md:block lg:block xl:block hidden" />
				<div class="md:flex lg:flex xl:flex hidden">
					<vs-button class="mr-3  font-bold" color="danger" type="border" @click="deleteSelected()">{{ $t("DeleteSelected") }}</vs-button>
					<vs-button class="mr-3  font-bold" color="danger" type="filled" @click="showDeleteConfirm()">{{ $t("DeleteAll") }}</vs-button>
					<vs-button class="font-bold" color="primary" type="filled" @click="markAllRead">{{ $t("MarkRead") }}</vs-button>
				</div>

				<div class="dropdown-button-container flex justify-end md:hidden lg:hidden xl:hidden">
					<vs-input @input="handleSearch" size="large" class="input-search mr-3" icon="search" :placeholder="$t('Actions.Search')" v-model="searching" />
					<vs-dropdown vs-custom-content vs-trigger-click>
						<vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
						<vs-dropdown-menu>
							<vs-dropdown-item>
								<vs-button class="ml-1 w-auto" color="danger" type="border" @click="deleteSelected()">{{ $t("DeleteSelected") }}</vs-button>
							</vs-dropdown-item>

							<vs-dropdown-item>
								<vs-button class="ml-1 w-auto" color="danger" type="filled" @click="showDeleteConfirm()">{{ $t("DeleteAll") }}</vs-button>
							</vs-dropdown-item>
							<vs-dropdown-item>
								<vs-button class="ml-1 w-auto" color="primary" type="filled" @click="markAllRead">{{ $t("MarkRead") }}</vs-button>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>
			</div>

			<template slot-scope="{ data }">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							<div class="flex">
								<noti-icon :ntf="tr" class="mr-1 mt-1" />
								<div>
									<h5 class="product-name font-medium" :class="[!tr.is_read ? `text-${'primary'}` : `text-${'dark'}`]" v-html="tr.title"></h5>
									<p v-html="tr.body"></p>
									<small :class="[{ 'text-primary': !tr.is_read, 'text-gray-3': tr.is_read }]">{{ tr.created_at }}</small>
								</div>
							</div>
						</vs-td>

						<vs-td class="whitespace-no-wrap">
							<i class="nucleo nucleo-link mr-4" @click.stop="gotoDetail(tr)"></i>
							<i class="nucleo nucleo-trash-can" @click.stop="showDeleteConfirm(tr.id)"></i>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<CbsPagination class="mt-3" :total="totalPages" v-model="currentx" />
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			selected: [],
			searching: "",
			currentx: 1,
			timer: null,
			isSearching: false
		};
	},
	computed: {
		totalPages() {
			return Math.ceil(this.$store.state.notifications.totalNotifications / this.$store.state.notifications.limitPerPage);
		},
		mapListIds() {
			return this.selected.map(item => item.id);
		},
		...mapGetters({
			getParsedNotificationList: "notifications/getParsedNotificationList"
		}),
		notifications() {
			return this.getParsedNotificationList || [];
		}
	},
	methods: {
		deleteSelected() {
			if (this.mapListIds.length > 0) {
				this.showDeleteConfirm();
			}
		},
		showDeleteConfirm(id) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteData(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		deleteData(id) {
			const _listIds = id ? [id] : this.mapListIds;
			this.$vs.loading({
				container: "#table-data-notifications",
				scale: 0.6
			});
			this.$store.dispatch("notifications/deleteNotifications", { listIds: _listIds, page: this.currentx }).then(() => {
				if (this.$store.state.notifications.notifications.length === 0) {
					this.currentx = this.currentx === 1 ? 1 : this.currentx - 1;
					this.$store.dispatch("notifications/fetchLatestNotifications", { limit: 5, page: 1 });
					this.$store.dispatch("notifications/fetchUnreadNotifications");
				}
				this.getNotifications();
				this.$vs.loading.close("#table-data-notifications > .con-vs-loading");
				this.selected = [];
			});
		},
		markAllRead() {
			this.$vs.loading({
				container: "#table-data-notifications",
				scale: 0.6
			});
			this.$store.dispatch("notifications/markAllReadNotifications", { listIds: this.mapListIds, page: this.currentx }).then(() => {
				this.$vs.loading.close("#table-data-notifications > .con-vs-loading");
			});
		},
		handleSearch(searching) {
			if (this.isSearching) return;
			this.searching = searching;
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.currentx = 1;
				this.getNotifications();
			}, 400);
		},
		getNotifications() {
			this.isSearching = true;
			this.$vs.loading({
				container: "#table-data-notifications",
				scale: 0.6
			});
			this.$store
				.dispatch("notifications/fetchNotifications", { search: this.searching, limit: this.$store.state.notifications.limitPerPage, page: this.currentx })
				.then(() => {
					this.isSearching = false;
					this.$vs.loading.close("#table-data-notifications > .con-vs-loading");
				})
				.catch(() => {
					this.isSearching = false;
					this.$vs.loading.close("#table-data-notifications > .con-vs-loading");
				});
		},
		gotoDetail(ntf) {
			if (!ntf.is_read) {
				// this.markAllRead([ntf.id]);
				this.$store.dispatch("notifications/onClickNotification", { notification: ntf });
			} else {
				this.$store.dispatch("notifications/redirectToDetailNotification", { notification: ntf });
			}
		}
	},
	created() {},
	mounted() {
		this.getNotifications();
	},
	watch: {
		currentx() {
			this.getNotifications();
		}
	}
};
</script>

<style lang="scss">
#data-list-list-view-notifications {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}
	}
}
</style>
